import React from 'react'
import { useHistory } from 'react-router-dom'

import IllustratedMessage from '@react/react-spectrum/IllustratedMessage'

import { openClient, RunProjectDialog } from 'views/Project/partials/RunProject'
import { PATHS } from 'config/constants'
import A from 'services/analytics'
import { archiveProject, duplicateProject } from 'services/project'
import { registerOpportunity } from 'services/opportunity'
import { useDialog } from 'hooks'

import ProjectCards from './ProjectCards'
import ProjectTable from './ProjectTable'

import './ProjectList.scss'

function ProjectList({ projects, canDelete, showOwner, viewMode, runOnClick }) {
  const history = useHistory()
  const { openDialog, closeDialog } = useDialog()

  const projectClickHandler = (project) => (e) => {
    e.stopPropagation()
    if (runOnClick) {
      if (openClient(project)) {
        openDialog(<RunProjectDialog project={project} onClose={closeDialog} />)
      }
    } else {
      history.push(`${PATHS.PROJECT_DETAILS}${project?.meta?.id}/screens`)
    }
  }

  // This function generates delete function for a given project or null if cannot delete.
  // If null is returned instead of a funciton, it signals item components to hide the delete button.
  const projectDeleteHandler = (project) =>
    canDelete
      ? () => {
          A.setProject(project)
          A.triggerDeleteProject()
          A.clearProject()
          archiveProject(project?.meta?.id)
        }
      : null

  const projectDuplicateHandler =
    (project) =>
    async ({ projectId, title, drNumber }) => {
      A.setProject(project)
      A.triggerCopyProject()
      A.clearProject()
      const responsePromise = duplicateProject(projectId, title)

      if (drNumber) {
        const response = await responsePromise
        const newId = response.data?.duplicateProject?.id
        if (newId) {
          registerOpportunity(drNumber, newId)
        }
      }
    }

  const DisplayOption = (props) => {
    switch (viewMode) {
      case 'table':
        return <ProjectTable {...props} />
      case 'smallCards':
        return <ProjectCards variant='small' {...props} />
      case 'cards':
      default:
        return <ProjectCards {...props} />
    }
  }

  return (
    <div className='projectList'>
      {(Array.isArray(projects) && projects.length > 0 && (
        <div className='projectList__content'>
          <DisplayOption
            projects={projects}
            projectClickHandler={projectClickHandler}
            projectDeleteHandler={projectDeleteHandler}
            projectDuplicateHandler={projectDuplicateHandler}
            showOwner={showOwner}
            runOnClick={runOnClick}
          />
        </div>
      )) || (
        <div className='projectList__placeholder'>
          <IllustratedMessage heading='No projects found' description='Start by creating a new project' />
        </div>
      )}
    </div>
  )
}

ProjectList.defaultProps = {
  showOwner: false,
  viewMode: null,
  runOnClick: false,
}

export default ProjectList
